// Site-count thresholds that determine which layout is rendered.
export const COMPACT_MAX = 8;
export const PIN_MIN = 16;
export const MAX_PINS = 6;
export const GRID_ROWS = 7;

// Minimum column width in pixels used for responsive row calculation.
export const COLUMN_MIN_WIDTH = 232;

export const PIN_LIMIT_TOOLTIP =
  "Max 6 sites pinned. Unpin a site to add another.";

// Site excluded from the "All sites" selection.
export const ALL_SITES_EXCLUDED_SITE = "ABBMINE";

export const MODULE = import.meta.env.VITE_MODULE_NAME ?? "";
export const IS_COPILOT = MODULE === "Copilot";
